<div
  [libBodyCssClassAppend]="appendTo"
  [targetCssClass]="'appended-to-body'"
  class="form-group position-relative {{ cssClass }}"
  *ngIf="control"
>
  <label *ngIf="label" class="col-form-label">
    {{ label }}<span *ngIf="isRequired" class="text-danger"> *</span>
  </label>
  <ng-select
    [formControl]="control"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [class.is-invalid]="control.touched && !control.valid && !control.disabled"
    [clearable]="clearable"
    [closeOnSelect]="closeOnSelect"
    [items]="items"
    [groupBy]="groupBy || null"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [multiple]="multiple"
    [searchable]="searchable"
    [dropdownPosition]="dropdownPosition"
    [appendTo]="appendTo"
    (change)="onChangeHandler($event)"
  >
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <span class="ng-value-label">{{ !!bindLabel ? item[bindLabel] : item }}</span>

      @let itemLocked = isItemLocked(item);
      <span
        class="ng-value-icon right"
        aria-hidden="true"
        [class.locked-item]="itemLocked"
        (click)="!itemLocked && clear(item)"
      >
        <img *ngIf="!itemLocked" alt="" src="assets/images/close.svg" width="16" height="16" />
        <i *ngIf="itemLocked" class="fas fa-lock"></i>
      </span>
    </ng-template>

    <ng-template ng-optgroup-tmp let-item="item">
      <span class="fw-semibold">{{ groupBy ? item[groupBy] : "" }}</span>
    </ng-template>

    <ng-template ng-option-tmp let-item="item">
      @let itemLocked = isItemLocked(item);
      <span [class.locked-item]="itemLocked" [class.highlighted-option]="item[bindHighlighted]">
        {{ !!this.bindLabel ? item[this.bindLabel] : item }}
        <i *ngIf="itemLocked" class="ms-1 fas fa-lock"></i>
      </span>
    </ng-template>
  </ng-select>
  <app-form-field-error *ngIf="control.touched && !control.valid" [errors]="control.errors"></app-form-field-error>
</div>
